import React from "react";
import "./employeeLeave.scss";
import { Table } from "reactstrap";
import moment from "moment";
function PlannedLeaves({ plannedleaveData }) {
	const tableHeader = [
		"Employee",
		"Leave Type",
		"Start Date",
		"End Date",
		"Approval Status",
	];

	return (
		<>
			<div className="plannedLeavesTitle">
				Planned leaves for this year
			</div>
			<Table borderless responsive className="leaveManagementTable">
				<thead className="tableHeader">
					<tr>
						{tableHeader.map((i, index) => {
							return (
								<th key={index} className={`text-justify`}>
									{i}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{plannedleaveData?.map((data, index) => {
						return (
							<tr
								key={index}
								className={`${
									index % 2 === 0 ? "row1" : "row2"
								}`}
							>
								<td className="text-justify">{data.name}</td>
								<td>{data.leaveType}</td>
								<td>
									{moment(data.startDate).format(
										"MM/DD/YYYY"
									)}
								</td>
								<td>
									{moment(data.endDate).format("MM/DD/YYYY")}
								</td>
								<td>{data.adminApprovalStatus}</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</>
	);
}

export default PlannedLeaves;
